import client from './client';

export const emailApi = {
  getTemplates: () =>
    client.get('/api/admin/email/templates'),

  sendBulk: (template_name: string, user_ids: string[], merge_vars?: Record<string, string>) =>
    client.post('/api/admin/email/send', { template_name, user_ids, merge_vars }),

  sendToSegment: (template_name: string, segment: Record<string, any>, merge_vars?: Record<string, string>) =>
    client.post('/api/admin/email/send-segment', { template_name, segment, merge_vars }),
};
